import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-review-message',
  templateUrl: './review-message.component.html',
  styleUrls: ['./review-message.component.css']
})
export class ReviewMessageComponent implements OnInit {

  customerReviewModelMessage: string;
  customerReviewModelMessageError: string;

  constructor(private modalService: NgbModal) { }

  ngOnInit() {
    this.customerReviewModelMessage = this.customerReviewModelMessage;
    this.customerReviewModelMessageError = this.customerReviewModelMessageError;
  }

  popupCloseButton() {
    this.modalService.dismissAll();
  }

  popOkButton() {
    this.modalService.dismissAll();
}

}
